import React, { useState, useContext } from "react";
import Button from "../../atoms/Button";
import { TopLoaderContext } from "../../../context/TopLoader";
import { resetPassword } from "../../../utils/API/resetPassword";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import SignupWall from "../SignupWall";
import { ReactComponent as Arrow } from "../../svgs/back-arrow.svg";
import { ReactComponent as Logo } from "../../svgs/logo.svg";
import { ReactComponent as Mail } from "../../svgs/mail.svg";
import { ReactComponent as Eye } from "../../svgs/eye.svg";
import Input from "../../atoms/Input";

const ResetPasswordForm = ({ userId, token }) => {
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { loadingRef } = useContext(TopLoaderContext);

  const onSubmitHandler = async (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      toast.error("Passwords are different");
      return;
    }
    try {
      loadingRef.current.continuousStart();
      await resetPassword({ password, userId, token }, dispatch);
      loadingRef.current.complete();
      setPassword("");
      setConfirmPassword("");
      toast.success("Password Changed Successfully!");
    } catch (err) {
      loadingRef.current.complete();
      toast.error(err.message);
    }
  };

  return (
    <div className="flex">
      <div className="shrink-0 grow-0 basis-[40%] h-auto relative  flex items-center justify-center">
        <SignupWall ReSetPassword={true}>
          <p className={` text-center text-lg leading-10 mb-4`}>
            Back to log in
          </p>
          <Link to={"sign-up"}>
            <Button
              color="white"
              varient="rounded"
              className="w-fit py-2 px-8 mx-auto text-2xl font-medium tracking-widest"
            >
              Log in
            </Button>
          </Link>
        </SignupWall>
      </div>

      <div className="shrink-0 grow-0 basis-[60%]">
        <div className="shrink-0 grow-0 flex flex-col items-left">
          <Link to={"/"}>
            <Button
              varient="rounded"
              borderColor="black"
              className="w-auto justify-center px-2.5 py-2 mt-6 ml-10 text-black  bg-white border border-black  hover:bg-gray-50  "
            >
              <div className="flex">
                <Arrow className="w-5 text-black" />
                <div className="font-bold text-sm pl-1 pr-2">Back to home</div>
              </div>
            </Button>
          </Link>
        </div>
        <div className="shrink-0 grow-0 flex flex-col items-center px-32 py-11">
          <Logo />
          <h2 className="text-4xl mt-6">Reset Your Password</h2>
          <p className="text-sm text-gray-500 mt-4">Enter your New Password</p>
          <form className="w-full mt-6" onSubmit={onSubmitHandler}>
            <Input
              type="password"
              id="password"
              label="New Password"
              className="w-full pt-8"
              Icon={Mail}
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              required={true}
            />

            <Input
              type="password"
              id="confirmPassword"
              label="Confirm New Password"
              className="w-full py-10"
              Icon={Eye}
              required={true}
              value={confirmPassword}
              onChange={(event) => {
                setConfirmPassword(event.target.value);
              }}
            />
            <div className="text-center">
              <Button
                varient="rounded"
                borderColor="black"
                color="blue"
                className="w-fit py-2 px-16 mx-auto text-2xl tracking-widest text-white mt-12"
                type="submit"
              >
                Reset
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordForm;

// <div className="flex flex-col border-2 border-black items-center w-full max-w-3xl py-12">
//   <h3 className="text-4xl font-bold mb-8">Reset Passwords</h3>
//   <form className="w-1/2" onSubmit={onSubmitHandler}>
//     <label htmlFor="password">
//       Password<span className="text-red-600 font-extrabold">*</span>
//     </label>
//     <input
//       type="password"
//       id="password"
//       value={password}
//       onChange={(event) => {
//         setPassword(event.target.value);
//       }}
//       className="mb-4 w-full p-1 outline-0 border-2 border-black block"
//     />

//     <label htmlFor="confirmPassword">
//       Confirm Password<span className="text-red-600 font-extrabold">*</span>
//     </label>
//     <input
//       type="password"
//       id="confirmPassword"
//       value={confirmPassword}
//       onChange={(event) => {
//         setConfirmPassword(event.target.value);
//       }}
//       className="mb-8 w-full p-1 outline-0 border-2 border-black block"
//     />
//     <Button
//       varient="primary"
//       borderColor="black"
//       color="blue"
//       className="text-lg px-7 py-2 mx-auto block text-white"
//       type="submit"
//     >
//       Reset Password
//     </Button>
//   </form>
// </div>
